import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION20: PdfComponent = {
  type: 'section',
  id: 's20',
  title: '20. Dispute Resolution',
  content: [
    {
      type: 'bulletList',
      id: 's20bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'Any dispute arising between the parties out of or in connection with this Agreement shall be dealt with in accordance with the provisions of this clause 20.',
        },
        {
          copy: 'The dispute resolution process may be initiated at any time by either party serving a notice in writing on the other party that a dispute has arisen. The notice shall include reasonable information as to the nature of the dispute.',
        },
        {
          copy: 'The parties shall use all reasonable endeavours to reach a negotiated resolution through the following procedures:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'within 7 days of service of the notice, the parties shall meet to discuss the dispute and attempt to resolve it;',
              },
              {
                copy: 'f the dispute has not been resolved within 7 days of the first meeting, then the matter shall be referred to the senior officer of each of the parties. The senior officers of the parties shall meet within 7 days of the date of such referral to discuss the dispute and attempt to resolve it.',
              },
            ],
          },
        },
        {
          copy: 'The specific format for the resolution of the dispute under clause 20.3(a) and, if necessary, clause 20.3(b) shall be left to the reasonable discretion of the parties, but may include the preparation and submission of statements of fact or of position.',
        },
        {
          copy: 'If the dispute has not been resolved within 14 days of the first meeting of the senior officers under clause 20.3(b), then the matter may be referred to mediation in accordance with the London Court of International Arbitration Mediation Rules.',
        },
        {
          copy: 'Until the parties have completed the steps referred to in clauses 20.3 and 20.5 and have failed to resolve the dispute, neither party shall commence formal legal proceedings or arbitration, except that either party may at any time seek urgent interim relief from the courts or emergency arbitrator relief.',
        },
      ],
      prefix: '20',
    },
  ],
};
